import { Box, Chip, Tooltip, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import CheckIcon from "@mui/icons-material/Check";
import { MESSAGE_CATEGORIES } from "../sites/alarmContact";

type Props = {
  selected: string[];
  disabled?: boolean;
  error?: string;
  onChange: (selected: string[]) => void;
};

// Velg hvilke meldingstyper en SMS-mottaker skal få. Samme komponent som i firemesh-appens
// nettstedsinnstillinger.
export default function MessageCategorySelector({ selected, disabled, error, onChange }: Props) {
  // Beholder rekkefølgen fra MESSAGE_CATEGORIES uansett i hvilken rekkefølge det klikkes
  const toggle = (value: string) =>
    onChange(
      selected.includes(value)
        ? selected.filter((v) => v !== value)
        : MESSAGE_CATEGORIES.map((c) => c.value).filter((v) => v === value || selected.includes(v))
    );

  return (
    <Box sx={{ opacity: disabled ? 0.5 : 1 }}>
      <Typography variant="caption" color="textSecondary">
        Meldingstyper
      </Typography>
      <Box role="group" aria-label="Meldingstyper" sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 0.5 }}>
        {MESSAGE_CATEGORIES.map((category) => {
          const isSelected = selected.includes(category.value);
          return (
            <Tooltip key={category.value} title={category.hint}>
              <Chip
                label={category.label}
                icon={isSelected ? <CheckIcon /> : undefined}
                color={isSelected ? "primary" : "default"}
                variant="outlined"
                size="small"
                aria-pressed={isSelected}
                disabled={disabled}
                onClick={() => toggle(category.value)}
                sx={
                  isSelected
                    ? { bgcolor: (theme) => alpha(theme.palette.primary.main, 0.12), fontWeight: 500 }
                    : undefined
                }
              />
            </Tooltip>
          );
        })}
      </Box>
      {error && (
        <Typography variant="caption" color="error" display="block">
          {error}
        </Typography>
      )}
    </Box>
  );
}
